export const provisionPipeline = `
    mutation provisionPipeline($input: ProvisionPipelineInput!) {
        provisionPipeline(input:$input) {
            id
            name
            description
            pipelineType
            pipelineStatus
            templateId
            codeRepositoryName
            branchName
            stackName
            buildCommand
            deploymentAccountGroupId
            stages {
              name
              order
              buildProvider
              deployProvider
              requiresApproval
              stageKind
              region
            }
            deploymentAccounts {
              accountId
              accountName
              region
              deploymentBucketName
            }
            createdByUsername
            created
            updated
        }
}`;

export const createPipeline = `
    mutation createPipeline($input: CreatePipelineInput!) {
        createPipeline(input:$input) {
            id
            name
            description
            pipelineType
            pipelineStatus
            templateId
            codeRepositoryName
            branchName
            buildCommand
            deploymentAccountGroupId
            stages {
              name
              order
              buildProvider
              deployProvider
              requiresApproval
              stageKind
              region
            }
            deploymentAccounts {
              accountId
              accountName
              region
              deploymentBucketName
            }
            createdByUsername
            created
    }
}`;

export const updatePipeline = `
    mutation updatePipeline($input: UpdatePipelineInput!) {
        updatePipeline(input:$input){
            id
            name
            description
            pipelineType
            pipelineStatus
            templateId
            branchName
            buildCommand
            stages {
              name
              order
              buildProvider
              deployProvider
              requiresApproval
              stageKind
              region
            }
            deploymentAccounts {
              accountId
              accountName
              region
              deploymentBucketName
            }
            createdByUsername
            created
            updated
        }
}`;

export const deletePipeline = `
    mutation deletePipeline($input: DeletePipelineInput!) {
        deletePipeline(input:$input)
}`;

export const migrateCodePipeline = `
    mutation migrateCodePipeline($input: MigrateCodePipelineInput!) {
        migrateCodePipeline(input:$input) {
            id
            name
            description
            pipelineType
            pipelineStatus
            templateId
            codeRepositoryName
            branchName
            buildCommand
            stages {
              name
              order
              buildProvider
              deployProvider
              requiresApproval
              stageKind
              region
            }
            deploymentAccounts {
              accountId
              accountName
              region
              deploymentBucketName
            }
            createdByUsername
            created
            updated
        }
}`;

export const reprovisionPipeline = `
    mutation reprovisionPipeline($input: ReprovisionPipelineInput!) {
        reprovisionPipeline(input:$input) {
            id
            name
            description
            pipelineType
            pipelineStatus
            templateId
            codeRepositoryName
            branchName
            stackName
            buildCommand
            deploymentAccountGroupId
            stages {
              name
              order
              buildProvider
              deployProvider
              requiresApproval
              stageKind
              region
            }
            deploymentAccounts {
              accountId
              accountName
              region
              deploymentBucketName
            }
            createdByUsername
            created
            updated
        }
}`;

export const cleanupMigratedPipeline = `
    mutation cleanupMigratedPipeline($input: CleanupMigratedPipelineInput!) {
        cleanupMigratedPipeline(input:$input) {
            id
            name
            description
            pipelineType
            pipelineStatus
            templateId
            codeRepositoryName
            branchName
            buildCommand
            stages {
              name
              order
              buildProvider
              deployProvider
              requiresApproval
              stageKind
              region
            }
            deploymentAccounts {
              accountId
              accountName
              region
              deploymentBucketName
            }
            createdByUsername
            created
            updated
        }
}`;
